// extracted by mini-css-extract-plugin
export default {"container":"legal_container__GuB+d","legal":"legal_legal__4XhSg"};